import React, { useContext } from 'react';
import * as Env from 'widget/env';

interface ContentContext {
  setIsCallbackActive: Env.SetState<boolean>;
  setIsChatActive: Env.SetState<boolean>;
}

const ContentContext = React.createContext<ContentContext>(
  {} as ContentContext,
);

export const useContentContext = () => useContext(ContentContext);
export default ContentContext;
